function displayLoader() {
    document.body.className = document.body.className.replace('loaded', '');
}

function hideLoader() {
    document.body.className += ' loaded';
}

window.addEventListener('beforeunload', function () {
    displayLoader();
});

window.addEventListener('pageshow', function () {
    hideLoader();
});
